import { FC } from "react";

import { FlexContainer, Icon, TinyText } from "shared/styles";
import { colors } from "shared/styles/constants";
import { ICoordinate } from "shared/types";
import { StyledTooltip } from "./styles";

export interface MapTooltipProps {
  icon?: React.ComponentType<any>;
  title?: string;
  content?: JSX.Element;
  coordinates: ICoordinate;
}

export const MapTooltip: FC<MapTooltipProps> = ({
  title,
  icon,
  content,
  coordinates,
}) => {
  return (
    <StyledTooltip
      {...coordinates}
      tipSize={5}
      closeOnClick={false}
      closeButton={false}
    >
      {title ? (
        <FlexContainer>
          {icon && <Icon as={icon} color={colors.grey1} />}
          <TinyText>{title}</TinyText>
        </FlexContainer>
      ) : (
        content
      )}
    </StyledTooltip>
  );
};
